// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_uj6","cls2":"TranslationModal-cls2_jrO TranslationModal-cls1_uj6"};